export const NAME = 'uploads3'

export const UPLOAD_SERVICE_S3 = `${NAME}/UPLOAD_SERVICE_S3`
export const UPLOAD_URL_AWS = `${NAME}/UPLOAD_URL_AWS`

export const FETCH_FOLDER_LIST = `${NAME}/FETCH_FOLDER_LIST`
export const FETCH_FOLDER_LIST_SUCCESS = `${NAME}/FETCH_FOLDER_LIST_SUCCESS`
export const FETCH_FOLDER_LIST_FAIL = `${NAME}/FETCH_FOLDER_LIST_FAIL`
